import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserModel } from 'app/_models/user-model';
import { AccountService } from 'app/_services/account.service';
import { UpdatePasswordComponent } from 'app/component/Accounts/UpdatePassword/update-password/update-password.component';
import { UserProfileComponent } from 'app/component/Accounts/user-profile/user-profile.component';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input() title: string;
  @Output() toggleSidebarEvent = new EventEmitter<void>();
  currentUser: UserModel;
  constructor(
    private readonly router: Router,
    private readonly accountService: AccountService,
    private readonly matDialog: MatDialog
    ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
  }

  
   emitToggleSidebarEvent() {
    this.toggleSidebarEvent.emit();
  }

  showProfile()
  {
    this.matDialog.open(UserProfileComponent, {
      width: "900px",
      disableClose: true,
      data: '',
    });
     
  }
  updatePassword()
  {
    this.matDialog.open(UpdatePasswordComponent, {
      width: "500px",
      disableClose: true,
      data: '',
    });
    
  }
  signout() {
    this.accountService.logout();
    this.router.navigateByUrl('/');
  }
  showDashboard()
  {
    this.router.navigateByUrl('/dashboard');
  }
}
